export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            精选重磅黑料专题，深度追踪最受关注的事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20entertainment%20gossip%20special%20feature%2C%20dramatic%20composition%20with%20red%20and%20dark%20tones%2C%20abstract%20artistic%20representation%20of%20breaking%20news%2C%20high%20contrast%20editorial%20style%2C%20warm%20crimson%20accents%2C%20mysterious%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape"
              alt="顶流恋情追踪专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                重磅专题
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                顶流恋情追踪
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                全方位揭秘娱乐圈顶流明星的情感世界
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20for%20entertainment%20variety%20show%20drama%2C%20dark%20dramatic%20composition%20with%20red%20and%20gold%20tones%2C%20TV%20studio%20abstract%20representation%2C%20high%20contrast%20editorial%20photography%2C%20mysterious%20spotlight%20effects&width=800&height=500&seq=carousel-02&orientation=landscape"
              alt="综艺翻车合集专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                爆笑合集
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                综艺翻车合集
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                各大综艺节目中令人捧腹的意外翻车名场面
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20about%20internet%20celebrity%20scandal%2C%20dark%20dramatic%20background%20with%20red%20glitch%20effects%2C%20digital%20social%20media%20abstract%20representation%2C%20high%20contrast%20editorial%20style%2C%20modern%20media%20aesthetic&width=800&height=500&seq=carousel-03&orientation=landscape"
              alt="网红翻车实录专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                深度揭秘
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                网红翻车实录
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                知名网红人设崩塌事件的完整时间线与内幕
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20banner%20for%20entertainment%20industry%20capital%20secrets%2C%20dark%20dramatic%20composition%20with%20gold%20and%20red%20accents%2C%20corporate%20boardroom%20abstract%20representation%2C%20high%20contrast%20editorial%20photography%2C%20mysterious%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape"
              alt="资本内幕专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                行业内幕
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                资本内幕
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                娱乐圈背后的资本运作与明星投资陷阱揭秘
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20banner%20for%20film%20and%20TV%20controversy%2C%20dark%20dramatic%20background%20with%20red%20and%20warm%20tones%2C%20movie%20set%20abstract%20representation%2C%20high%20contrast%20editorial%20style%2C%20cinematic%20lighting%20effects%2C%20professional%20composition&width=800&height=500&seq=carousel-05&orientation=landscape"
              alt="影视争议专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                热门争议
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                影视争议
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                热门影视剧改编争议与抄袭质疑事件全面梳理
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden aspect-[16/10] cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20for%20year%20end%20entertainment%20review%2C%20dark%20dramatic%20composition%20with%20crimson%20and%20gold%20highlights%2C%20collage%20abstract%20representation%2C%20high%20contrast%20editorial%20style%2C%20warm%20atmospheric%20lighting%2C%20retrospective%20theme&width=800&height=500&seq=carousel-06&orientation=landscape"
              alt="年度盘点专题"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-label font-semibold mb-2 whitespace-nowrap">
                年度特辑
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug">
                年度盘点
              </h3>
              <p className="mt-1 text-sm text-white/70 hidden sm:block">
                年度最具影响力的黑料事件完整回顾与深度分析
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}